module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel05_1280_1280_th-3c282b3b3b1a047ffea1150160a73210.jpg";